<div id="quote-attachments-page"
     class="body-padding px-8 py-4 bg-white rounded-lg shadow flex flex-col gap-4 justify-center">
  <h1 id="quote-attachments-header" class="text-lg font-semibold">
    Quote
    <a id="quote-attachments-link"
       (click)="goToQuotePage()"
       class="text-blue-500 underline cursor-pointer">{{ quoteId }}</a>
    Attachments ({{ totalItems }})
  </h1>

  <div id="quote-attachments-grid" class="px-8 py-4 rounded-lg flex justify-center items-start gap-4 flex-wrap">
    @for (item of paginatedImages; track $index; let i = $index) {
      <attachment-card [attachment]="item" [idPostfix]="String(i)"/>
    }
  </div>

  @if (paginatedImages.length == 0) {
    <loading-pulse [pulseCount]="5"/>
  }

  <div id="quote-attachments-pagination"
       class="w-full text-sm flex justify-between bg-white rounded-b-xl align-baseline items-baseline font-semibold pb-1 pt-1 p-2">
    <div id="quote-pagination-info" class="flex">
      <div class="mr-2 pl-2 text-gray-500 flex">
        Showing {{ (page - 1) * itemsPerPage + 1 }} - {{ Math.min(page * itemsPerPage, totalItems) }}
        of {{ totalItems }}
        @if (paginatedImages.length == 0 || showLoading) {
          <div id="quote-pagination-spinner" class="pr-1 pl-1 flex">
            <svg aria-hidden="true"
                 class="w-6 h-6 text-gray-200 animate-spin fill-red-600"
                 viewBox="0 0 100 101"
                 fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"/>
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"/>
            </svg>
          </div>
        }
      </div>
    </div>
    <div id="quote-pagination-controls" class="flex justify-center">
      <button id="quote-pagination-prev"
              class="submit-button m-2 p-2 hover:bg-yellow-100"
              [disabled]="page === 1"
              (click)="prevPage()">
        <svg style="transform: scaleX(-1);" width="5" height="8" fill="none" class="_ZSSm0">
          <path d="M1 1l3 3-3 3"
                stroke="currentcolor"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"></path>
        </svg>
      </button>
      <span id="quote-pagination-pages" class="m-2 text-gray-500 pl-1 pr-1">
        <span class="text-gray-900">
          <input id="quote-pagination-input"
                 [(ngModel)]="page"
                 type="text"
                 class="w-10 border-none text-sm p-0 focus:outline-none focus:border-none focus:ring-0">
          <span class="pl-1 pr-1">of</span>
          <span id="quote-pagination-total">{{ totalPages }}</span>
        </span>
      </span>
      <button id="quote-pagination-next"
              class="submit-button m-2 p-2 hover:bg-yellow-100"
              [disabled]="page === totalPages"
              (click)="nextPage()">
        <svg width="5" height="8" fill="none" class="">
          <path d="M1 1l3 3-3 3"
                stroke="currentcolor"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"></path>
        </svg>
      </button>
    </div>
  </div>
</div>
